/**
 * SUSA South Africa Theme
 * JavaScript for interactions and functionality
 */

(function() {
  'use strict';

  // Mobile Menu
  function initMobileMenu() {
    const mobileToggle = document.querySelector('[data-mobile-toggle]');
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    const mobileClose = document.querySelector('[data-mobile-close]');
    const mobileBackdrop = document.querySelector('[data-mobile-backdrop]');

    if (!mobileToggle || !mobileMenu) return;

    mobileToggle.addEventListener('click', () => {
      mobileMenu.classList.add('is-open');
      mobileBackdrop?.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    });

    mobileClose?.addEventListener('click', closeMobileMenu);
    mobileBackdrop?.addEventListener('click', closeMobileMenu);

    function closeMobileMenu() {
      mobileMenu.classList.remove('is-open');
      mobileBackdrop?.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  }

  // Header Scroll Effect
  function initHeaderScroll() {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    let lastScroll = 0;

    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY;

      if (currentScroll > 50) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }

      lastScroll = currentScroll;
    });
  }

  // Cart Functionality
  function initCart() {
    const cartToggle = document.querySelector('[data-cart-toggle]');
    const cartDrawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('overlay');

    if (!cartToggle || !cartDrawer) return;

    cartToggle.addEventListener('click', () => {
      cartDrawer.classList.add('is-open');
      overlay?.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      loadCart();
    });

    // ESC key to close cart
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) {
        window.closeCart();
      }
    });

    function loadCart() {
      showCartLoading();
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          renderCart(cart);
        })
        .catch(error => {
          console.error('Error loading cart:', error);
          document.getElementById('cart-drawer-content').innerHTML =
            '<div class="cart-empty"><p class="cart-empty__message">Error loading cart. Please refresh the page.</p></div>';
        });
    }

    function showCartLoading() {
      document.getElementById('cart-drawer-content').innerHTML = `
        <div class="cart-loading">
          <div class="cart-loading__spinner"></div>
        </div>
      `;
    }

    function renderCart(cart) {
      const contentArea = document.getElementById('cart-drawer-content');

      if (cart.items.length === 0) {
        contentArea.innerHTML = `
          <div class="cart-empty">
            <svg class="cart-empty__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="9" cy="21" r="1"/>
              <circle cx="20" cy="21" r="1"/>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
            </svg>
            <p class="cart-empty__message">Your cart is empty</p>
            <button type="button" class="cart-empty__btn" onclick="closeCart()">Continue Shopping</button>
          </div>
        `;
        // Hide footer when cart is empty
        const footer = document.querySelector('.cart-drawer__footer');
        if (footer) footer.style.display = 'none';

        // Update cart count badge to 0 when empty
        const cartCounts = document.querySelectorAll('[data-cart-count]');
        cartCounts.forEach(count => {
          count.textContent = '0';
        });
        return;
      }

      // Show footer
      const footer = document.querySelector('.cart-drawer__footer');
      if (footer) footer.style.display = 'block';

      // Check if Pink VIP membership is in cart
      const config = window.SUSA_CONFIG?.pinkVIP;
      const customer = config?.customer;
      const membershipInCart = config ? cart.items.some(item => item.handle === config.productHandle) : false;
      const isLoggedIn = customer && customer.id;
      const discountPercent = config ? config.discountPercent : 12;

      // Build cart items HTML
      let itemsHTML = '<ul class="cart-items">';

      cart.items.forEach((item, index) => {
        const lineItem = index + 1;
        const variantOptions = item.variant_options || [];
        const hasVariants = variantOptions.length > 0 && variantOptions[0] !== 'Default Title';
        const isPinkVIP = config && item.handle === config.productHandle;

        // Calculate discounted price if Pink VIP is in cart (show preview even for guests)
        const showDiscount = membershipInCart && !isPinkVIP;
        const originalPrice = item.final_line_price;
        const discountedPrice = showDiscount ? Math.round(originalPrice * (1 - discountPercent / 100)) : originalPrice;
        const savings = originalPrice - discountedPrice;

        itemsHTML += `
          <li class="cart-item">
            <div class="cart-item__image">
              <img src="${item.featured_image?.url || item.image}" alt="${item.title}" loading="lazy">
            </div>
            <div class="cart-item__info">
              <h3 class="cart-item__title">${item.product_title}</h3>
              ${hasVariants ? `<p class="cart-item__variant">${variantOptions.join(' / ')}</p>` : ''}
              ${showDiscount ? `
                <p class="cart-item__price">
                  <span style="text-decoration: line-through; color: #999; font-size: 0.9em;">${Shopify.formatMoney(originalPrice)} TTD</span>
                  <span style="color: #E91E63; font-weight: bold; font-size: 1.1em;">${Shopify.formatMoney(discountedPrice)} TTD</span>
                </p>
              ` : `
                <p class="cart-item__price">${Shopify.formatMoney(item.final_line_price)} TTD</p>
              `}
              <div class="cart-item__quantity">
                <button class="qty-btn" onclick="updateCartQuantity(${lineItem}, ${item.quantity - 1})" ${item.quantity <= 1 ? 'disabled' : ''} aria-label="Decrease quantity">−</button>
                <span class="qty-display">${item.quantity}</span>
                <button class="qty-btn" onclick="updateCartQuantity(${lineItem}, ${item.quantity + 1})" aria-label="Increase quantity">+</button>
                <button class="cart-item__remove" onclick="removeCartItem(${lineItem})" aria-label="Remove item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="3 6 5 6 21 6"/>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                  </svg>
                  Remove
                </button>
              </div>
            </div>
          </li>
        `;
      });

      itemsHTML += '</ul>';

      // Pink VIP Upsell Banner (only for non-members who don't have VIP in cart)
      itemsHTML += renderPinkVIPUpsell(cart);

      // Add cart notes
      itemsHTML += `
        <div class="cart-notes">
          <label class="cart-notes__label" for="cart-note">Order Instructions (Optional)</label>
          <textarea
            id="cart-note"
            class="cart-notes__textarea"
            placeholder="Add special instructions for your order..."
            onblur="saveCartNote(this.value)"
          >${cart.note || ''}</textarea>
        </div>
      `;

      contentArea.innerHTML = itemsHTML;

      // Update footer
      updateCartFooter(cart);

      // Update Pink VIP header savings
      if (window.updatePinkVIPHeaderSavings) {
        updatePinkVIPHeaderSavings();
      }

      // Generate VIP code silently in background (don't redirect yet)
      if (membershipInCart && isLoggedIn && customer.email) {
        generateVIPCodeSilently(customer.email);
      }
    }

    function renderGuestVIPMessage() {
      // Message shown to guests who have Pink VIP in cart but aren't logged in
      const returnUrl = encodeURIComponent(window.location.pathname + '?cart=open');

      return `
        <div class="guest-vip-message" style="background: linear-gradient(135deg, #FFE5F0 0%, #FFF0F7 100%); border: 2px solid #E91E63; border-radius: 12px; padding: 20px; margin: 16px 0; text-align: center;">
          <div style="font-size: 32px; margin-bottom: 12px;">🎀</div>
          <h3 style="color: #E91E63; font-size: 18px; margin-bottom: 8px; font-weight: bold;">Sign In to Use Pink Membership</h3>
          <p style="color: #666; font-size: 14px; margin-bottom: 16px;">
            Log in to apply your Pink VIP discount to this order.
          </p>
          <a
            href="/account/login?return_url=${returnUrl}"
            style="display: inline-block; background: #E91E63; color: white; padding: 12px 24px; border-radius: 8px; text-decoration: none; font-weight: bold; font-size: 16px;"
          >
            Sign In
          </a>
        </div>
      `;
    }

    function renderPinkVIPUpsell(cart) {
      // Don't show if config not loaded
      if (!window.SUSA_CONFIG || !window.SUSA_CONFIG.pinkVIP) return '';

      const config = window.SUSA_CONFIG.pinkVIP;
      const customer = config.customer;

      // Don't show if already a Pink VIP member
      if (customer.isPinkMember) return '';

      // Check if Pink VIP membership is already in cart
      const membershipInCart = cart.items.some(item =>
        item.handle === config.productHandle
      );

      // Don't show if membership already in cart
      if (membershipInCart) return '';

      // Calculate product subtotal (excluding membership if somehow in cart)
      let productSubtotal = 0;
      cart.items.forEach(item => {
        if (item.handle !== config.productHandle) {
          productSubtotal += item.final_line_price;
        }
      });

      // Calculate potential savings (12% of product subtotal)
      const potentialSavings = Math.round(productSubtotal * (config.discountPercent / 100));
      const formattedSavings = Shopify.formatMoney(potentialSavings);
      const formattedSubtotal = Shopify.formatMoney(productSubtotal);
      const formattedMembershipPrice = Shopify.formatMoney(config.membershipPrice);

      // Only show if there are products in cart (not just membership)
      if (productSubtotal === 0) return '';

      return `
        <div class="pink-vip-upsell">
          <div class="pink-vip-upsell__header">
            <span class="pink-vip-upsell__icon">🎀</span>
            <h3 class="pink-vip-upsell__title">JOIN PINK VIP & SAVE ${config.discountPercent}% ON THIS ORDER!</h3>
          </div>
          <div class="pink-vip-upsell__content">
            <div class="pink-vip-upsell__calculation">
              <p class="pink-vip-upsell__line">Your cart: <strong>${formattedSubtotal} TTD</strong></p>
              <p class="pink-vip-upsell__line">Pink VIP Membership: <strong>${formattedMembershipPrice} TTD</strong></p>
            </div>
            <div class="pink-vip-upsell__benefits">
              <p class="pink-vip-upsell__savings">✨ <strong>Save ${formattedSavings} TTD on this order!</strong></p>
              <p class="pink-vip-upsell__yearly">🎁 Plus save ${config.discountPercent}% on every purchase all year!</p>
            </div>
            <button
              type="button"
              class="pink-vip-upsell__btn"
              onclick="addPinkVIPMembership()"
            >
              ✓ Add Pink VIP Membership - Save ${formattedSavings} TTD Now!
            </button>
          </div>
        </div>
      `;
    }

    function updateCartFooter(cart) {
      const footer = document.querySelector('.cart-drawer__footer');

      // Check if Pink VIP is in cart
      const config = window.SUSA_CONFIG?.pinkVIP;
      const customer = config?.customer;
      const membershipInCart = config ? cart.items.some(item => item.handle === config.productHandle) : false;
      const isLoggedIn = customer && customer.id;
      const discountPercent = config ? config.discountPercent : 12;

      // Calculate Pink VIP savings (show for both logged in and guests as preview)
      let vipSavings = 0;
      if (membershipInCart) {
        cart.items.forEach(item => {
          const isPinkVIP = config && item.handle === config.productHandle;
          if (!isPinkVIP) {
            vipSavings += Math.round(item.final_line_price * (discountPercent / 100));
          }
        });
      }

      // Check if there's a Shopify discount applied (from discount code)
      const hasShopifyDiscount = cart.total_discount && cart.total_discount > 0;
      const shopifyDiscountAmount = cart.total_discount || 0;
      const finalTotal = cart.total_price; // This is already the discounted price
      const originalTotal = finalTotal + shopifyDiscountAmount; // Calculate original price before discount

      // Build footer content (without wrapper div)
      let footerContent;

      // Determine checkout button behavior based on Pink VIP + login status
      let checkoutButton;

      if (membershipInCart && !isLoggedIn) {
        // Guest with Pink VIP - block checkout, force decision
        checkoutButton = `<button type="button" class="cart-checkout-btn" onclick="showGuestVIPCheckoutModal()">Proceed to Checkout</button>`;
      } else if (vipSavings > 0) {
        // Logged in with VIP - apply code on checkout
        checkoutButton = `<button type="button" class="cart-checkout-btn" onclick="proceedToCheckoutWithVIP()">Proceed to Checkout</button>`;
      } else {
        // Normal checkout
        checkoutButton = `<a href="/checkout" class="cart-checkout-btn">Proceed to Checkout</a>`;
      }

      // Show footer based on VIP savings or Shopify discount
      if (vipSavings > 0) {
        // finalTotal = cart.total_price (undiscounted). discountedTotal = after VIP savings.
        const discountedTotal = finalTotal - vipSavings;

        footerContent = `
            <div style="padding: 6px 0; margin-bottom: 8px; text-align: center;">
              <span style="color: #4CAF50; font-weight: 500; font-size: 13px;">
                🎀 Total Savings with Pink VIP: ${Shopify.formatMoney(vipSavings)}
              </span>
            </div>
            <div class="cart-total">
              <span class="cart-total__label">Subtotal</span>
              <span class="cart-total__price">
                <span style="text-decoration: line-through; color: #ccc; font-size: 0.85em; margin-right: 8px;">${Shopify.formatMoney(finalTotal)}</span>
                <span style="color: #E91E63; font-weight: bold;">${Shopify.formatMoney(discountedTotal)} TTD</span>
              </span>
            </div>
            ${checkoutButton}
        `;
      } else if (hasShopifyDiscount) {
        footerContent = `
            <div class="cart-savings">
              <span class="cart-savings__icon">💝</span>
              <span class="cart-savings__text">Saving ${Shopify.formatMoney(shopifyDiscountAmount)} with Pink VIP</span>
            </div>
            <div class="cart-total">
              <span class="cart-total__label">Total</span>
              <span class="cart-total__price">
                <span class="cart-total__original">${Shopify.formatMoney(originalTotal)}</span>
                ${Shopify.formatMoney(finalTotal)} TTD
              </span>
            </div>
            ${checkoutButton}
        `;
      } else {
        footerContent = `
            <div class="cart-total">
              <span class="cart-total__label">Subtotal</span>
              <span class="cart-total__price">${Shopify.formatMoney(finalTotal)} TTD</span>
            </div>
            ${checkoutButton}
        `;
      }

      if (!footer) {
        // Create footer if it doesn't exist
        const footerHTML = `<div class="cart-drawer__footer">${footerContent}</div>`;
        document.getElementById('cart-drawer').insertAdjacentHTML('beforeend', footerHTML);
      } else {
        // Update existing footer (directly set innerHTML, no regex)
        footer.innerHTML = footerContent;
      }
    }

    // Generate VIP code silently (don't redirect - save for checkout)
    async function generateVIPCodeSilently(customerEmail) {
      // Check if we've already generated a code for this session
      if (window.SUSA_VIP_CODE_GENERATED) return;

      try {
        // Call backend to generate unique one-time code
        const response = await fetch(`${window.BACKEND_API_URL}/api/vip/create-code`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            customerEmail: customerEmail
          })
        });

        const data = await response.json();

        if (!data.success) {
          console.error('Failed to generate VIP code:', data.error);
          return;
        }

        const vipCode = data.code;
        console.log('VIP code generated silently:', vipCode);

        // Mark as generated and store code
        window.SUSA_VIP_CODE_GENERATED = true;
        window.SUSA_VIP_CURRENT_CODE = vipCode;

        // Don't redirect - code will be applied when user clicks checkout

      } catch (error) {
        console.error('Error generating VIP code:', error);
      }
    }

    // Make function globally accessible
    window.generateVIPCodeSilently = generateVIPCodeSilently;

    // Make these functions global so they can be called from onclick
    window.loadCart = loadCart;
    window.addPinkVIPMembership = addPinkVIPMembership;
    window.applyPinkVIPDiscount = applyPinkVIPDiscount;
  }

  // Backend API URL for VIP code generation (make global)
  window.BACKEND_API_URL = 'https://backend-production-ec02.up.railway.app';
  const BACKEND_API_URL = window.BACKEND_API_URL;

  // Add Pink VIP Membership to cart with one click
  function addPinkVIPMembership() {
    if (!window.SUSA_CONFIG || !window.SUSA_CONFIG.pinkVIP) {
      alert('Configuration error. Please refresh the page.');
      return;
    }

    const config = window.SUSA_CONFIG.pinkVIP;
    const customer = config.customer;

    // REMOVED LOGIN CHECK - Allow guests to add VIP membership
    // Membership tracking will happen after purchase via backend

    // Show loading state
    const btn = event.target;
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    // First, get the Pink VIP product to find its variant ID
    fetch(`/products/${config.productHandle}.js`)
      .then(response => response.json())
      .then(product => {
        // Get the first (and likely only) variant
        const variantId = product.variants[0].id;

        // Add to cart
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });
      })
      .then(response => response.json())
      .then(() => {
        // Generate and apply unique VIP discount code (only for logged-in users)
        if (customer && customer.id && customer.email) {
          return generateAndApplyVIPCode(customer.email);
        }
        // For guests, skip discount code generation (applied at checkout)
        return Promise.resolve();
      })
      .then(() => {
        // Reload cart to show the membership
        if (window.loadCart) {
          window.loadCart();
        }

        // Open cart drawer to show VIP was added
        const cartDrawer = document.getElementById('cart-drawer');
        const overlay = document.getElementById('overlay');
        if (cartDrawer) {
          cartDrawer.classList.add('is-open');
          if (overlay) overlay.classList.add('is-active');
        }

        // Update cart count badge
        if (typeof updateCartCount === 'function') {
          updateCartCount();
        }

        // Update the banner to show success message
        const banner = btn.closest('.banner-g2');
        if (banner) {
          // Get the savings amount from the banner
          const savingsElement = banner.querySelector('[data-savings-amount]');
          const savingsAmount = savingsElement ? savingsElement.textContent : '';

          // Update banner content
          banner.classList.remove('banner-g2--cta');
          banner.classList.add('banner-g2--success');
          banner.innerHTML = `
            <div class="banner-g2__success-icon">✅</div>
            <div class="banner-g2__text-block">
              <strong>Pink VIP Membership Added!</strong> You now save ${savingsAmount} on this item (12% off) Valid for entire year
            </div>
          `;
        }
      })
      .catch(error => {
        console.error('Error adding Pink VIP Membership:', error);
        alert('Unable to add membership. Please try again or add it manually from the product page.');
        btn.textContent = originalText;
        btn.disabled = false;
      });
  }

  // Generate unique VIP code and auto-apply it
  async function generateAndApplyVIPCode(customerEmail) {
    try {
      // Call backend to generate unique one-time code
      const response = await fetch(`${BACKEND_API_URL}/api/vip/create-code`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          customerEmail: customerEmail || 'guest@susatt.com'
        })
      });

      const data = await response.json();

      if (!data.success) {
        console.error('Failed to generate VIP code:', data.error);
        return;
      }

      const vipCode = data.code;
      console.log('VIP code generated:', vipCode);

      // Auto-apply the code to cart
      window.location.href = `/discount/${vipCode}`;

    } catch (error) {
      console.error('Error generating VIP code:', error);
      // Don't block the flow if code generation fails
      // Cart still has VIP membership, just no auto-discount
    }
  }

  // Apply Pink VIP first-purchase discount code
  function applyPinkVIPDiscount() {
    if (!window.SUSA_CONFIG || !window.SUSA_CONFIG.pinkVIP) {
      return Promise.resolve();
    }

    const discountCode = window.SUSA_CONFIG.pinkVIP.discountCode;

    // Apply discount code to cart
    return fetch('/discount/' + discountCode, {
      method: 'GET'
    }).then(() => {
      console.log('Pink VIP discount applied:', discountCode);
    }).catch(error => {
      console.error('Error applying discount:', error);
      // Don't fail the whole process if discount doesn't apply
    });
  }

  // Show guest membership modal
  function showGuestMembershipModal() {
    const modal = document.getElementById('guest-membership-modal');
    const overlay = document.getElementById('overlay');
    if (modal && overlay) {
      modal.classList.add('active');
      overlay.classList.add('active');
      document.body.classList.add('modal-open');
    }
  }

  // Close guest membership modal
  function closeGuestMembershipModal() {
    const modal = document.getElementById('guest-membership-modal');
    const overlay = document.getElementById('overlay');
    if (modal && overlay) {
      modal.classList.remove('active');
      overlay.classList.remove('active');
      document.body.classList.remove('modal-open');
    }
  }

  // Make modal functions global
  window.showGuestMembershipModal = showGuestMembershipModal;
  window.closeGuestMembershipModal = closeGuestMembershipModal;

  // Check Pink VIP membership expiry on page load
  function checkPinkVIPExpiry() {
    if (!window.SUSA_CONFIG || !window.SUSA_CONFIG.pinkVIP) return;

    const config = window.SUSA_CONFIG.pinkVIP;
    const customer = config.customer;

    // Only check for logged-in Pink VIP members
    if (!customer.id || !customer.isPinkMember) return;

    // Check if expiry date exists
    if (!customer.vipExpiryDate) return;

    // Parse expiry date
    const expiryDate = new Date(customer.vipExpiryDate);
    const today = new Date();

    // Check if membership has expired
    if (today > expiryDate) {
      // Show expiry notification
      showExpiryNotification();
    } else {
      // Calculate days remaining
      const daysRemaining = Math.ceil((expiryDate - today) / (1000 * 60 * 60 * 24));

      // Show renewal reminder if less than 30 days remaining
      if (daysRemaining <= 30 && daysRemaining > 0) {
        showRenewalReminder(daysRemaining);
      }
    }
  }

  function showExpiryNotification() {
    // Create expiry banner
    const banner = document.createElement('div');
    banner.className = 'pink-vip-expiry-banner';
    banner.innerHTML = `
      <div class="pink-vip-expiry-banner__content">
        <span class="pink-vip-expiry-banner__icon">🎀</span>
        <p class="pink-vip-expiry-banner__text">Your Pink VIP Membership has expired! Renew now to keep saving 12%</p>
        <a href="/products/susa-pink-vip-membership-exclusive-yearlong-savings" class="pink-vip-expiry-banner__btn">Renew Membership</a>
        <button type="button" class="pink-vip-expiry-banner__close" onclick="this.parentElement.parentElement.remove()" aria-label="Close">×</button>
      </div>
    `;
    document.body.insertAdjacentElement('afterbegin', banner);
  }

  function showRenewalReminder(daysRemaining) {
    // Create renewal reminder banner
    const banner = document.createElement('div');
    banner.className = 'pink-vip-renewal-banner';
    banner.innerHTML = `
      <div class="pink-vip-renewal-banner__content">
        <span class="pink-vip-renewal-banner__icon">🎀</span>
        <p class="pink-vip-renewal-banner__text">Your Pink VIP Membership expires in ${daysRemaining} day${daysRemaining > 1 ? 's' : ''}. Renew now!</p>
        <a href="/products/susa-pink-vip-membership-exclusive-yearlong-savings" class="pink-vip-renewal-banner__btn">Renew</a>
        <button type="button" class="pink-vip-renewal-banner__close" onclick="this.parentElement.parentElement.remove()" aria-label="Close">×</button>
      </div>
    `;
    document.body.insertAdjacentElement('afterbegin', banner);
  }

  // Run expiry check when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkPinkVIPExpiry);
  } else {
    checkPinkVIPExpiry();
  }

  // Update Pink VIP header indicator with cart savings
  function updatePinkVIPHeaderSavings() {
    if (!window.SUSA_CONFIG || !window.SUSA_CONFIG.pinkVIP) return;

    const config = window.SUSA_CONFIG.pinkVIP;
    const customer = config.customer;

    // Only update for non-members (members already have their badge)
    if (customer.isPinkMember) return;

    // Get the header promo text element
    const promoText = document.querySelector('[data-vip-promo]');
    if (!promoText) return;

    // Fetch current cart
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Calculate product subtotal (excluding membership if in cart)
        let productSubtotal = 0;
        cart.items.forEach(item => {
          if (item.handle !== config.productHandle) {
            productSubtotal += item.final_line_price;
          }
        });

        // If cart is empty, show default message
        if (productSubtotal === 0) {
          if (customer.id) {
            promoText.textContent = 'Join Pink VIP - Save 12%';
          } else {
            promoText.textContent = 'Pink VIP Members save 12%!';
          }
          return;
        }

        // Calculate savings
        const savings = Math.round(productSubtotal * (config.discountPercent / 100));
        const formattedSavings = Shopify.formatMoney(savings);

        // Update text with actual savings
        if (customer.id) {
          promoText.textContent = `Join Pink VIP - Save ${formattedSavings} on your cart!`;
        } else {
          promoText.textContent = `Pink VIP saves ${formattedSavings} on your cart!`;
        }
      })
      .catch(error => {
        console.error('Error fetching cart for VIP savings:', error);
      });
  }

  // Update header savings on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updatePinkVIPHeaderSavings);
  } else {
    updatePinkVIPHeaderSavings();
  }

  // Update header savings when cart changes
  document.addEventListener('cart:updated', updatePinkVIPHeaderSavings);

  // Make function global so it can be called after cart operations
  window.updatePinkVIPHeaderSavings = updatePinkVIPHeaderSavings;

  // Pink VIP Product Page Badge - Show and update savings
  function initPinkVIPProductBadge() {
    if (!window.SUSA_CONFIG || !window.SUSA_CONFIG.pinkVIP) return;

    const badge = document.getElementById('pink-vip-product-badge');
    if (!badge) return;

    const config = window.SUSA_CONFIG.pinkVIP;
    const customer = config.customer;

    // Show badge for all visitors (customer state handled in Liquid)
    badge.style.display = 'block';

    // Only update savings dynamically if there are variant selectors
    const variantInputs = document.querySelectorAll('input[name^="options["]');
    if (variantInputs.length === 0) return;

    // Listen for variant changes
    variantInputs.forEach(input => {
      input.addEventListener('change', updateProductBadgeSavings);
    });

    // Update when variant dropdown changes (for traditional selects)
    const variantSelects = document.querySelectorAll('select[name^="options["]');
    variantSelects.forEach(select => {
      select.addEventListener('change', updateProductBadgeSavings);
    });
  }

  // Update savings amount when variant changes
  function updateProductBadgeSavings() {
    if (!window.SUSA_CONFIG || !window.SUSA_CONFIG.pinkVIP) return;

    const badge = document.getElementById('pink-vip-product-badge');
    if (!badge) return;

    try {
      // Get product variants data from JSON script tag
      const variantsData = document.getElementById('product-variants-json');
      if (!variantsData) return;

      const data = JSON.parse(variantsData.textContent);

      // Get selected variant ID from hidden input
      const selectedVariantId = document.querySelector('input[name="id"]')?.value;
      if (!selectedVariantId) return;

      // Find the selected variant
      const selectedVariant = data.variants.find(v => v.id == selectedVariantId);
      if (!selectedVariant) return;

      // Calculate 12% savings on variant price
      const config = window.SUSA_CONFIG.pinkVIP;
      const price = selectedVariant.price;
      const savings = Math.round(price * (config.discountPercent / 100));

      // Format savings using Shopify's money format
      const formattedSavings = Shopify.formatMoney(savings);

      // Update all savings amount displays in the badge
      const savingsElements = badge.querySelectorAll('[data-savings-amount]');
      savingsElements.forEach(element => {
        element.textContent = formattedSavings;
      });
    } catch (error) {
      console.error('Error updating product badge savings:', error);
    }
  }

  // Initialize product badge on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPinkVIPProductBadge);
  } else {
    initPinkVIPProductBadge();
  }

  // Product Form (Add to Cart)
  function initProductForm() {
    const productForm = document.getElementById('product-form');
    if (!productForm) return;

    // Update option labels when options are selected
    const optionInputs = productForm.querySelectorAll('.color-swatch__input, .option-button__input');
    optionInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        const selectedValue = e.target.value;
        const optionContainer = e.target.closest('.product-option');
        const optionLabel = optionContainer.querySelector('[data-option-value]');

        if (optionLabel) {
          optionLabel.textContent = selectedValue.toUpperCase();
        }
      });
    });

    productForm.addEventListener('submit', (e) => {
      e.preventDefault();

      const formData = new FormData(productForm);
      const submitButton = productForm.querySelector('button[type="submit"]');
      const originalText = submitButton.textContent;

      submitButton.textContent = 'Adding...';
      submitButton.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(item => {
        // Update cart count
        updateCartCount();

        // Show success message
        submitButton.textContent = '✓ Added!';
        submitButton.style.background = 'var(--color-gold)';

        setTimeout(() => {
          submitButton.textContent = originalText;
          submitButton.disabled = false;
          submitButton.style.background = '';
        }, 2000);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        submitButton.textContent = 'Error - Try Again';
        submitButton.disabled = false;

        setTimeout(() => {
          submitButton.textContent = originalText;
        }, 2000);
      });
    });
  }

  // Variant Availability Checker
  function initVariantAvailability() {
    const productForm = document.getElementById('product-form');
    if (!productForm) return;

    // Get variant data from JSON
    const variantDataElement = document.getElementById('product-variants-json');
    if (!variantDataElement) return;

    const variantData = JSON.parse(variantDataElement.textContent);
    const variants = variantData.variants;

    // Get all option inputs
    const optionInputs = productForm.querySelectorAll('.color-swatch__input, .option-button__input');
    const submitButton = productForm.querySelector('button[type="submit"]');
    const hiddenVariantInput = productForm.querySelector('input[name="id"]');

    // Function to get currently selected options
    function getSelectedOptions() {
      const selected = {};
      const optionContainers = productForm.querySelectorAll('.product-option');

      optionContainers.forEach(container => {
        const checkedInput = container.querySelector('input:checked');
        if (checkedInput) {
          const optionName = checkedInput.name.match(/\[(.*?)\]/)[1]; // Extract option name from "options[Size]"
          selected[optionName] = checkedInput.value;
        }
      });

      return selected;
    }

    // Function to find matching variant based on selected options
    function findMatchingVariant(selectedOptions) {
      return variants.find(variant => {
        let matches = true;
        const optionNames = Object.keys(selectedOptions);

        optionNames.forEach((optionName, index) => {
          const variantOption = variant[`option${index + 1}`];
          if (variantOption !== selectedOptions[optionName]) {
            matches = false;
          }
        });

        return matches;
      });
    }

    // Function to get available options for a specific option type
    function getAvailableOptions(optionName, selectedOptions) {
      const availableValues = new Set();

      variants.forEach(variant => {
        if (!variant.available) return; // Skip unavailable variants

        // Check if this variant matches other selected options
        let matchesOthers = true;
        const optionNames = Object.keys(selectedOptions);

        optionNames.forEach((otherOptionName, index) => {
          if (otherOptionName === optionName) return; // Skip the option we're checking

          const variantOption = variant[`option${index + 1}`];
          if (variantOption !== selectedOptions[otherOptionName]) {
            matchesOthers = false;
          }
        });

        if (matchesOthers) {
          // Find which option index this is
          const optionIndex = optionNames.indexOf(optionName);
          const value = variant[`option${optionIndex + 1}`];
          if (value) availableValues.add(value);
        }
      });

      return availableValues;
    }

    // Function to update option availability UI
    function updateOptionAvailability() {
      const selectedOptions = getSelectedOptions();

      // Update each option's availability
      productForm.querySelectorAll('.product-option').forEach(optionContainer => {
        const optionLabel = optionContainer.querySelector('.product-option__label');
        const optionName = optionLabel.textContent.split(':')[0].trim();

        const availableValues = getAvailableOptions(optionName, selectedOptions);

        // Update each option input
        optionContainer.querySelectorAll('input[type="radio"]').forEach(input => {
          const value = input.value;
          const label = input.nextElementSibling;
          const isAvailable = availableValues.has(value);

          if (isAvailable) {
            input.disabled = false;
            label.classList.remove('unavailable');
          } else {
            input.disabled = true;
            label.classList.add('unavailable');
          }
        });
      });

      // Update hidden variant ID and submit button
      const matchingVariant = findMatchingVariant(selectedOptions);

      if (matchingVariant) {
        hiddenVariantInput.value = matchingVariant.id;

        if (matchingVariant.available) {
          submitButton.disabled = false;
          submitButton.textContent = 'Add to Cart';
        } else {
          submitButton.disabled = true;
          submitButton.textContent = 'Sold Out';
        }
      } else {
        submitButton.disabled = true;
        submitButton.textContent = 'Select Options';
      }
    }

    // Listen for option changes
    optionInputs.forEach(input => {
      input.addEventListener('change', updateOptionAvailability);
    });

    // Initial check
    updateOptionAvailability();
  }

  // Update Cart Count
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCounts = document.querySelectorAll('[data-cart-count]');
        cartCounts.forEach(count => {
          count.textContent = cart.item_count;
        });
      });
  }

  // Quick Add to Cart (from product cards)
  function initQuickAdd() {
    const quickAddButtons = document.querySelectorAll('.product-card__quick-add');

    quickAddButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation(); // Prevent card link click
        const productHandle = button.dataset.productHandle;

        // Fetch product data to get variants
        fetch(`/products/${productHandle}.js`)
          .then(response => response.json())
          .then(product => {
            if (product.variants.length === 1) {
              // Only one variant, add directly
              addToCartQuick(product.variants[0].id, button);
            } else {
              // Multiple variants, show modal
              showQuickAddModal(product);
            }
          })
          .catch(error => {
            console.error('Error fetching product:', error);
            alert('Unable to load product options');
          });
      });
    });
  }

  function showQuickAddModal(product) {
    // Create modal HTML
    const modalHTML = `
      <div id="quick-add-modal" class="quick-add-modal">
        <div class="quick-add-modal__overlay" onclick="closeQuickAddModal()"></div>
        <div class="quick-add-modal__content">
          <button class="quick-add-modal__close" onclick="closeQuickAddModal()" aria-label="Close">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>

          <div class="quick-add-modal__product">
            <div class="quick-add-modal__image">
              <img src="${product.featured_image}" alt="${product.title}" loading="lazy">
            </div>
            <div class="quick-add-modal__info">
              <h3 class="quick-add-modal__title">${product.title}</h3>
              <p class="quick-add-modal__price">${Shopify.formatMoney(product.price)}</p>

              <form id="quick-add-form" class="quick-add-modal__form">
                ${generateVariantSelectors(product)}

                <button type="submit" class="quick-add-modal__submit">
                  Add to Cart
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    `;

    // Insert modal into body
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    document.body.style.overflow = 'hidden';

    // Handle form submission
    const form = document.getElementById('quick-add-form');
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const formData = new FormData(form);
      const selectedVariantId = formData.get('variant_id');

      if (!selectedVariantId) {
        alert('Please select all options');
        return;
      }

      const submitBtn = form.querySelector('button[type="submit"]');
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Adding...';
      submitBtn.disabled = true;

      addToCartQuick(selectedVariantId, submitBtn, originalText);
    });

    // Handle variant selection changes
    const variantSelects = document.querySelectorAll('.quick-add-variant-select');
    variantSelects.forEach(select => {
      select.addEventListener('change', () => updateSelectedVariant(product));
    });

    // Initialize selected variant
    updateSelectedVariant(product);
  }

  function generateVariantSelectors(product) {
    // Get unique option names (Size, Color, etc.)
    const options = product.options;
    let html = '';

    options.forEach((option, index) => {
      if (option.name === 'Title' && option.values.length === 1 && option.values[0] === 'Default Title') {
        return; // Skip default title
      }

      // Sort size values intelligently
      let values = [...option.values];
      if (option.name.toLowerCase().includes('size') || option.name.toLowerCase().includes('cup')) {
        values.sort(compareSizes);
      }

      html += `
        <div class="quick-add-variant-option">
          <label class="quick-add-variant-label">${option.name}</label>
          <select
            class="quick-add-variant-select"
            data-option-index="${index + 1}"
            required
          >
            <option value="">Select ${option.name}</option>
            ${values.map(value => `
              <option value="${value}">${value}</option>
            `).join('')}
          </select>
        </div>
      `;
    });

    html += '<input type="hidden" name="variant_id" id="selected-variant-id">';
    return html;
  }

  function updateSelectedVariant(product) {
    const selects = document.querySelectorAll('.quick-add-variant-select');
    const selectedOptions = {};

    // Get selected values
    selects.forEach(select => {
      const optionIndex = select.dataset.optionIndex;
      selectedOptions[optionIndex] = select.value;
    });

    // Find matching variant
    const matchingVariant = product.variants.find(variant => {
      return Object.keys(selectedOptions).every(index => {
        return variant[`option${index}`] === selectedOptions[index];
      });
    });

    // Update hidden input and price
    const variantInput = document.getElementById('selected-variant-id');
    const priceDisplay = document.querySelector('.quick-add-modal__price');
    const submitBtn = document.querySelector('.quick-add-modal__submit');

    if (matchingVariant) {
      variantInput.value = matchingVariant.id;
      priceDisplay.textContent = Shopify.formatMoney(matchingVariant.price);

      if (matchingVariant.available) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Add to Cart';
      } else {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sold Out';
      }
    } else {
      variantInput.value = '';
      submitBtn.disabled = true;
    }
  }

  function addToCartQuick(variantId, button, originalText = 'Add to Cart') {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(item => {
      updateCartCount();
      button.textContent = '✓ Added!';

      setTimeout(() => {
        if (document.getElementById('quick-add-modal')) {
          closeQuickAddModal();
        } else {
          button.textContent = originalText;
          button.disabled = false;
        }
      }, 1500);
    })
    .catch(error => {
      console.error('Error:', error);
      button.textContent = 'Error - Try Again';
      button.disabled = false;
    });
  }

  function closeQuickAddModal() {
    const modal = document.getElementById('quick-add-modal');
    if (modal) {
      modal.remove();
      document.body.style.overflow = '';
    }
  }

  // Make closeQuickAddModal global for onclick
  window.closeQuickAddModal = closeQuickAddModal;

  // Smooth Scroll for Anchor Links
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '#') return;

        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  // Lazy Load Images
  function initLazyLoad() {
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.classList.remove('lazy');
            observer.unobserve(img);
          }
        });
      });

      document.querySelectorAll('img.lazy').forEach(img => {
        imageObserver.observe(img);
      });
    }
  }

  // Newsletter Form
  function initNewsletter() {
    const newsletterForms = document.querySelectorAll('.newsletter-form');

    newsletterForms.forEach(form => {
      form.addEventListener('submit', (e) => {
        const submitButton = form.querySelector('button[type="submit"]');
        const originalText = submitButton.textContent;

        submitButton.textContent = 'Subscribing...';
        submitButton.disabled = true;

        // Shopify will handle the form submission
        // This just provides visual feedback

        setTimeout(() => {
          submitButton.textContent = '✓ Subscribed!';

          setTimeout(() => {
            submitButton.textContent = originalText;
            submitButton.disabled = false;
          }, 2000);
        }, 1000);
      });
    });
  }

  // Auto-open cart if returning from login with ?cart=open
  function checkAutoOpenCart() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('cart') === 'open') {
      // Open cart drawer
      const cartDrawer = document.getElementById('cart-drawer');
      const overlay = document.getElementById('overlay');
      if (cartDrawer && overlay) {
        cartDrawer.classList.add('is-open');
        overlay.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        if (window.loadCart) {
          window.loadCart();
        }
      }

      // Clean up URL (remove ?cart=open)
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  }

  // Initialize all functions when DOM is ready
  // Sort Product Variant Sizes Intelligently
  function sortProductSizes() {
    const optionContainers = document.querySelectorAll('.option-buttons');

    optionContainers.forEach(container => {
      const buttons = Array.from(container.querySelectorAll('.option-button__input'));
      if (buttons.length === 0) return;

      // Get all size values
      const sizes = buttons.map(input => ({
        input: input,
        label: input.nextElementSibling,
        value: input.value
      }));

      // Sort the sizes
      sizes.sort((a, b) => compareSizes(a.value, b.value));

      // Reorder DOM elements
      sizes.forEach(item => {
        container.appendChild(item.input);
        container.appendChild(item.label);
      });
    });
  }

  function compareSizes(a, b) {
    // Bra size comparison (e.g., 34B/C, 36DD, 40DDD)
    const braPattern = /^(\d+)([A-Z]+)(?:\/([A-Z]+))?$/i;
    const aMatch = a.match(braPattern);
    const bMatch = b.match(braPattern);

    if (aMatch && bMatch) {
      // Both are bra sizes
      const aBand = parseInt(aMatch[1]);
      const bBand = parseInt(bMatch[1]);

      if (aBand !== bBand) {
        return aBand - bBand; // Sort by band size first
      }

      // Same band, sort by cup size
      const aCup = aMatch[2].toUpperCase();
      const bCup = bMatch[2].toUpperCase();
      return compareCupSizes(aCup, bCup);
    }

    // Standard sizes (XS, S, M, L, XL, XXL, XXXL)
    const sizeOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '2XL', '3XL', '4XL', '5XL'];
    const aUpper = a.toUpperCase();
    const bUpper = b.toUpperCase();
    const aIndex = sizeOrder.indexOf(aUpper);
    const bIndex = sizeOrder.indexOf(bUpper);

    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex;
    }

    // Numeric sizes (2, 4, 6, 8, 10, etc.)
    const aNum = parseFloat(a);
    const bNum = parseFloat(b);

    if (!isNaN(aNum) && !isNaN(bNum)) {
      return aNum - bNum;
    }

    // Shoe sizes with decimals (7.5, 8, 8.5, 9, etc.)
    if (a.includes('.') || b.includes('.')) {
      return parseFloat(a) - parseFloat(b);
    }

    // Default: alphabetical
    return a.localeCompare(b);
  }

  function compareCupSizes(a, b) {
    const cupOrder = ['A', 'B', 'C', 'D', 'DD', 'DDD', 'E', 'F', 'G', 'H'];
    const aIndex = cupOrder.indexOf(a);
    const bIndex = cupOrder.indexOf(b);

    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex;
    }

    return a.localeCompare(b);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initMobileMenu();
    initHeaderScroll();
    initCart();
    initProductForm();
    initVariantAvailability(); // Check variant availability
    initQuickAdd();
    initSmoothScroll();
    initLazyLoad();
    initNewsletter();
    updateCartCount();
    sortProductSizes(); // Sort sizes after page loads
    checkAutoOpenCart(); // Auto-open cart if returning from login
  });

})();

// Global Cart Functions (accessible from onclick handlers)
function closeCart() {
  const cartDrawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('overlay');

  if (cartDrawer) {
    cartDrawer.classList.remove('is-open');
  }
  if (overlay) {
    overlay.classList.remove('is-active');
  }
  document.body.style.overflow = '';
}

function removeCartItem(lineItem) {
  // Show loading in cart
  const contentArea = document.getElementById('cart-drawer-content');
  if (contentArea) {
    contentArea.innerHTML = `
      <div class="cart-loading">
        <div class="cart-loading__spinner"></div>
      </div>
    `;
  }

  // First, check what item is being removed (to detect Pink VIP removal)
  fetch('/cart.js')
    .then(response => response.json())
    .then(currentCart => {
      const removedItem = currentCart.items[lineItem - 1];
      const isPinkVIP = window.SUSA_CONFIG?.pinkVIP && removedItem.handle === window.SUSA_CONFIG.pinkVIP.productHandle;

      // Remove item by setting quantity to 0
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: lineItem,
          quantity: 0
        })
      }).then(response => ({ response, isPinkVIP }));
    })
    .then(({ response, isPinkVIP }) => response.json().then(cart => ({ cart, isPinkVIP })))
    .then(({ cart, isPinkVIP }) => {
      // If Pink VIP was removed, void the code and reset generation flag
      if (isPinkVIP) {
        voidVIPCode();
      }

      // Update cart count badge first
      const cartCounts = document.querySelectorAll('[data-cart-count]');
      cartCounts.forEach(count => {
        count.textContent = cart.item_count;
      });

      // Reload cart to show updated state
      if (window.loadCart) {
        window.loadCart();
      }
    })
    .catch(error => {
      console.error('Error removing item:', error);
      alert('Error removing item from cart. Please try again.');
      if (window.loadCart) {
        window.loadCart();
      }
    });
}

// Void VIP code when Pink VIP is removed from cart
async function voidVIPCode() {
  if (!window.SUSA_VIP_CURRENT_CODE) return;

  try {
    await fetch(`${window.BACKEND_API_URL}/api/vip/mark-used`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        code: window.SUSA_VIP_CURRENT_CODE,
        orderNumber: null // No order number = voided
      })
    });

    console.log('VIP code voided:', window.SUSA_VIP_CURRENT_CODE);

    // Reset flags
    window.SUSA_VIP_CODE_GENERATED = false;
    window.SUSA_VIP_CURRENT_CODE = null;

  } catch (error) {
    console.error('Error voiding VIP code:', error);
  }
}

// Make voidVIPCode globally accessible
window.voidVIPCode = voidVIPCode;

// Proceed to checkout with VIP discount applied
function proceedToCheckoutWithVIP() {
  window.location.href = '/checkout?discount=PINKVIP';
}

// Make globally accessible
window.proceedToCheckoutWithVIP = proceedToCheckoutWithVIP;

// Show modal when guest tries to checkout with Pink VIP in cart
function showGuestVIPCheckoutModal() {
  // Create modal HTML
  const modalHTML = `
    <div id="guest-vip-checkout-modal" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.7); z-index: 10000; display: flex; align-items: center; justify-content: center;">
      <div style="background: white; border-radius: 16px; max-width: 500px; width: 90%; padding: 32px; text-align: center; position: relative;">
        <button onclick="closeGuestVIPCheckoutModal()" style="position: absolute; top: 16px; right: 16px; background: none; border: none; font-size: 24px; cursor: pointer; color: #999;">&times;</button>

        <div style="font-size: 48px; margin-bottom: 16px;">🎀</div>
        <h2 style="color: #E91E63; font-size: 22px; margin-bottom: 12px; font-weight: bold;">Sign In Required for Pink VIP</h2>
        <p style="color: #666; font-size: 15px; margin-bottom: 24px; line-height: 1.6;">
          Pink VIP Membership must be linked to your account. Please choose an option:
        </p>

        <div style="display: flex; flex-direction: column; gap: 12px;">
          <a
            href="/customer_authentication/login?return_to=%2Fcheckout%3Fdiscount%3DPINKVIP"
            style="display: block; background: #E91E63; color: white; padding: 16px 24px; border-radius: 8px; text-decoration: none; font-weight: bold; font-size: 16px; transition: background 0.2s;"
          >
            ✓ Sign In to Keep Pink VIP
          </a>

          <button
            onclick="removePinkVIPAndCheckout()"
            style="background: #fff; color: #E91E63; border: 2px solid #E91E63; padding: 16px 24px; border-radius: 8px; font-weight: bold; font-size: 16px; cursor: pointer; transition: all 0.2s;"
          >
            Remove Pink VIP & Checkout as Guest
          </button>
        </div>

        <p style="color: #999; font-size: 13px; margin-top: 16px;">
          Note: Checking out as guest will remove the Pink VIP Membership from your cart.
        </p>
      </div>
    </div>
  `;

  // Insert modal into body
  document.body.insertAdjacentHTML('beforeend', modalHTML);
  document.body.style.overflow = 'hidden';
}

// Close guest VIP checkout modal
function closeGuestVIPCheckoutModal() {
  const modal = document.getElementById('guest-vip-checkout-modal');
  if (modal) {
    modal.remove();
    document.body.style.overflow = '';
  }
}

// Remove Pink VIP from cart and proceed to checkout
async function removePinkVIPAndCheckout() {
  const config = window.SUSA_CONFIG?.pinkVIP;
  if (!config) {
    window.location.href = '/checkout';
    return;
  }

  try {
    // Get current cart
    const response = await fetch('/cart.js');
    const cart = await response.json();

    // Find Pink VIP item
    const vipItemIndex = cart.items.findIndex(item => item.handle === config.productHandle);

    if (vipItemIndex !== -1) {
      const lineItem = vipItemIndex + 1;

      // Remove Pink VIP from cart
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: lineItem,
          quantity: 0
        })
      });

      // Void any generated code
      if (window.voidVIPCode) {
        await window.voidVIPCode();
      }
    }

    // Close modal and proceed to checkout
    closeGuestVIPCheckoutModal();
    window.location.href = '/checkout';

  } catch (error) {
    console.error('Error removing Pink VIP:', error);
    // Proceed to checkout anyway
    closeGuestVIPCheckoutModal();
    window.location.href = '/checkout';
  }
}

// Make globally accessible
window.showGuestVIPCheckoutModal = showGuestVIPCheckoutModal;
window.closeGuestVIPCheckoutModal = closeGuestVIPCheckoutModal;
window.removePinkVIPAndCheckout = removePinkVIPAndCheckout;

function updateCartQuantity(lineItem, newQuantity) {
  if (newQuantity < 1) return; // Prevent quantity less than 1

  // Show loading in cart
  const contentArea = document.getElementById('cart-drawer-content');
  if (contentArea) {
    contentArea.innerHTML = `
      <div class="cart-loading">
        <div class="cart-loading__spinner"></div>
      </div>
    `;
  }

  // Update quantity via Cart API
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      line: lineItem,
      quantity: newQuantity
    })
  })
  .then(response => response.json())
  .then(cart => {
    // Update cart count badge first
    const cartCounts = document.querySelectorAll('[data-cart-count]');
    cartCounts.forEach(count => {
      count.textContent = cart.item_count;
    });

    // Reload cart to show updated state
    if (window.loadCart) {
      window.loadCart();
    }
  })
  .catch(error => {
    console.error('Error updating quantity:', error);
    alert('Error updating item quantity. Please try again.');
    if (window.loadCart) {
      window.loadCart();
    }
  });
}

function saveCartNote(note) {
  // Save cart note via Cart API
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      note: note
    })
  })
  .then(response => response.json())
  .then(cart => {
    console.log('Cart note saved');
  })
  .catch(error => {
    console.error('Error saving cart note:', error);
  });
}

// Make cart functions globally accessible for onclick handlers
window.closeCart = closeCart;
window.removeCartItem = removeCartItem;
window.updateCartQuantity = updateCartQuantity;
window.saveCartNote = saveCartNote;

// Shopify Currency Formatting (if not available)
if (typeof Shopify === 'undefined') {
  Shopify = {};
}

Shopify.formatMoney = function(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || '${{amount}}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number === null) {
      return '0';
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// ====================================
// SEARCH SIDE PANEL
// ====================================

(function() {
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchPanel = document.querySelector('[data-search-panel]');
  const searchBackdrop = document.querySelector('[data-search-backdrop]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = document.querySelector('[data-search-input]');
  const searchLoading = document.querySelector('[data-search-loading]');
  const searchItems = document.querySelector('[data-search-items]');
  const searchNoResults = document.querySelector('[data-search-no-results]');

  if (!searchToggle || !searchPanel) return;

  let searchTimeout = null;

  // Open search panel
  function openSearch() {
    searchPanel.classList.add('active');
    searchBackdrop.classList.add('active');
    document.body.style.overflow = 'hidden';
    setTimeout(() => {
      searchInput.focus();
    }, 100);
  }

  // Close search panel
  function closeSearch() {
    searchPanel.classList.remove('active');
    searchBackdrop.classList.remove('active');
    document.body.style.overflow = '';
    searchInput.value = '';
    hideAllResults();
  }

  // Hide all result states
  function hideAllResults() {
    searchLoading.style.display = 'none';
    searchItems.style.display = 'none';
    searchNoResults.style.display = 'none';
  }

  // Show different search states
  function showSearchState(state) {
    hideAllResults();
    if (state === 'loading') {
      searchLoading.style.display = 'block';
    } else if (state === 'results') {
      searchItems.style.display = 'flex';
    } else if (state === 'no-results') {
      searchNoResults.style.display = 'block';
    }
  }

  // Perform search using Shopify's Predictive Search API
  function performSearch(query) {
    if (!query || query.length < 2) {
      hideAllResults();
      return;
    }

    showSearchState('loading');

    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`)
        .then(response => response.json())
        .then(data => {
          displayResults(data.resources.results.products || []);
        })
        .catch(error => {
          console.error('Search error:', error);
          showSearchState('no-results');
        });
    }, 300);
  }

  // Display search results
  function displayResults(products) {
    if (products.length === 0) {
      showSearchState('no-results');
      return;
    }

    showSearchState('results');

    searchItems.innerHTML = products.map(product => {
      const price = Shopify.formatMoney(product.price);
      const imageUrl = product.image || '';

      return `
        <a href="${product.url}" class="search-result-item">
          <img src="${imageUrl}" alt="${product.title}" class="search-result-item__image" loading="lazy">
          <div class="search-result-item__info">
            <div class="search-result-item__title">${product.title}</div>
            <div class="search-result-item__price">${price}</div>
          </div>
        </a>
      `;
    }).join('');
  }

  // Event listeners
  searchToggle.addEventListener('click', (e) => {
    e.preventDefault();
    openSearch();
  });

  searchClose.addEventListener('click', closeSearch);
  searchBackdrop.addEventListener('click', closeSearch);

  // Live search on input
  searchInput.addEventListener('input', (e) => {
    performSearch(e.target.value.trim());
  });

  // Prevent form submission
  const searchForm = document.querySelector('.search-panel-form');
  if (searchForm) {
    searchForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const query = searchInput.value.trim();
      if (query) {
        window.location.href = `/search?q=${encodeURIComponent(query)}&type=product`;
      }
    });
  }
})();

// ====================================
// ACCOUNT DROPDOWN MENU
// ====================================
(function() {
  'use strict';

  const accountToggle = document.querySelector('[data-account-toggle]');
  const accountDropdown = document.querySelector('[data-account-dropdown]');

  if (!accountToggle || !accountDropdown) return;

  let isOpen = false;

  // Toggle dropdown
  accountToggle.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isOpen) {
      closeDropdown();
    } else {
      openDropdown();
    }
  });

  function openDropdown() {
    accountDropdown.classList.add('active');
    isOpen = true;

    // Close on outside click
    setTimeout(() => {
      document.addEventListener('click', handleOutsideClick);
    }, 10);
  }

  function closeDropdown() {
    accountDropdown.classList.remove('active');
    isOpen = false;
    document.removeEventListener('click', handleOutsideClick);
  }

  function handleOutsideClick(e) {
    if (!accountDropdown.contains(e.target) && !accountToggle.contains(e.target)) {
      closeDropdown();
    }
  }

  // Close dropdown when escape key is pressed
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen) {
      closeDropdown();
    }
  });

})();

// ===== LOGIN REDIRECT =====
(function initLoginRedirect() {
  // Save current page before navigating to login
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href*="/account/login"], a[href*="/account/register"], .modal__btn[href*="/account"]');
    if (link && window.location.pathname.indexOf('/account') !== 0) {
      localStorage.setItem('susa_login_redirect', window.location.href);
    }
  });

  // After login Shopify lands on /account — redirect back to saved page
  var isAccountPage = window.location.pathname.indexOf('/account') === 0
    && window.location.pathname !== '/account/login'
    && window.location.pathname !== '/account/register'
    && window.location.pathname !== '/account/recover';

  if (isAccountPage) {
    var config = window.SUSA_CONFIG && window.SUSA_CONFIG.pinkVIP;
    // customer.loggedIn is set by Liquid in theme.liquid (customer.id is never set there)
    var isLoggedIn = (config && config.customer && config.customer.loggedIn)
      || document.querySelector('a[href="/account/logout"], .account-page__logout');

    if (isLoggedIn) {
      var redirectUrl = localStorage.getItem('susa_login_redirect');
      if (redirectUrl) {
        localStorage.removeItem('susa_login_redirect');
        if (redirectUrl.indexOf(window.location.origin) === 0
            && redirectUrl.indexOf('/account') === -1
            && redirectUrl !== window.location.href) {
          window.location.href = redirectUrl;
        }
      }
    }
  }
})();

// ---- SUSA Variant Controller ----
// Full takeover of variant selection for PageFly product pages.
// Behavior: no pre-selection on load, global availability shown, click to filter,
// click selected option again to deselect, both color+size selected = Add to Cart active.
(function() {
  var _ready = false;
  var _variants = null;
  var _positions = {};
  var _selected = {};

  function init() {
    if (_ready) return;
    var dataEl = document.getElementById('product-variants-json');
    var form = document.querySelector('#product-form');
    if (!dataEl || !form) return;

    try {
      var data = JSON.parse(dataEl.textContent);
      _variants = data.variants || data;
    } catch(e) { return; }

    _positions = {};
    form.querySelectorAll('.product-option').forEach(function(c, i) {
      var lbl = c.querySelector('.product-option__label');
      if (lbl) _positions[lbl.textContent.split(':')[0].trim()] = i + 1;
    });
    if (Object.keys(_positions).length === 0) return;

    _ready = true;
    _selected = {};

    // Auto-select options that have only ONE available value (e.g. "Shapewear support level: High")
    Object.keys(_positions).forEach(function(name) {
      var pos = _positions[name];
      var vals = [];
      _variants.forEach(function(v) {
        if (v['option' + pos] && v.available && vals.indexOf(v['option' + pos]) === -1)
          vals.push(v['option' + pos]);
      });
      if (vals.length === 1) {
        _selected[name] = vals[0];
        var input = form.querySelector('input[name="options[' + name + ']"][value="' + vals[0] + '"]');
        if (input) input.checked = true;
      }
    });

    // Clear PageFly's default selection for multi-value options
    form.querySelectorAll('input[type="radio"]').forEach(function(input) {
      var m = input.name.match(/\[(.*?)\]/);
      if (!m) return;
      var name = m[1].trim();
      if (!_selected[name]) input.checked = false;
      input.disabled = false;
    });

    // Inject CSS for filtered (not matching current selection but has global stock)
    if (!document.getElementById('susa-vc-css')) {
      var s = document.createElement('style');
      s.id = 'susa-vc-css';
      s.textContent = '.susa-filtered { opacity: 0.35; text-decoration: line-through; cursor: pointer !important; }';
      document.head.appendChild(s);
    }

    updateDisplay();
    updateSubmit();

    // Capture-phase listener on form to intercept clicks before PageFly
    form.addEventListener('click', handleClick, true);
  }

  function globalAvail(name, value) {
    var pos = _positions[name];
    if (!pos) return false;
    return _variants.some(function(v) { return v['option' + pos] === value && v.available; });
  }

  function filteredAvail(name, value) {
    var pos = _positions[name];
    if (!pos) return false;
    return _variants.some(function(v) {
      if (v['option' + pos] !== value || !v.available) return false;
      return Object.keys(_selected).every(function(n) {
        if (n === name) return true;
        var p = _positions[n];
        return p && v['option' + p] === _selected[n];
      });
    });
  }

  function updateDisplay() {
    var form = document.querySelector('#product-form');
    if (!form) return;
    var hasSelection = Object.keys(_selected).length > 0;

    form.querySelectorAll('.product-option').forEach(function(container) {
      var lbl = container.querySelector('.product-option__label');
      if (!lbl) return;
      var name = lbl.textContent.split(':')[0].trim();

      // Store original label text once, then update to show selected value
      if (!lbl._originalText) lbl._originalText = lbl.textContent;
      var baseName = lbl._originalText.split(':')[0];
      if (_selected[name]) {
        lbl.textContent = baseName + ': ' + _selected[name].toUpperCase();
      } else {
        lbl.textContent = lbl._originalText;
      }

      container.querySelectorAll('input[type="radio"]').forEach(function(input) {
        var el = input.nextElementSibling;
        var value = input.value;

        if (!globalAvail(name, value)) {
          // Zero global stock — disabled and crossed out permanently
          input.disabled = true;
          if (el) { el.classList.add('unavailable'); el.classList.remove('susa-filtered'); }
          return;
        }

        // Has global stock — always clickable
        input.disabled = false;

        if (hasSelection && !filteredAvail(name, value)) {
          // Not available in current filter — crossed out but still clickable
          if (el) { el.classList.add('susa-filtered'); el.classList.remove('unavailable'); }
        } else {
          // Available — clean
          if (el) { el.classList.remove('unavailable', 'susa-filtered'); }
        }
      });
    });
  }

  function updateSubmit() {
    var form = document.querySelector('#product-form');
    if (!form) return;
    var btn = form.querySelector('button[type="submit"]');
    var hiddenId = form.querySelector('input[name="id"]');
    if (!btn) return;

    // Only require options with more than one available value to be selected
    var required = Object.keys(_positions).filter(function(name) {
      var pos = _positions[name];
      var vals = [];
      _variants.forEach(function(v) {
        if (v['option' + pos] && v.available && vals.indexOf(v['option' + pos]) === -1) vals.push(v['option' + pos]);
      });
      return vals.length > 1;
    });

    var allPicked = required.every(function(name) { return !!_selected[name]; });
    if (!allPicked) {
      btn.disabled = true;
      btn.textContent = 'Select Options';
      return;
    }

    var match = _variants.find(function(v) {
      return Object.keys(_positions).every(function(name) {
        var pos = _positions[name];
        return v['option' + pos] === _selected[name];
      });
    });

    if (match) {
      if (hiddenId) hiddenId.value = match.id;
      btn.disabled = !match.available;
      btn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
    } else {
      btn.disabled = true;
      btn.textContent = 'Select Options';
    }
  }

  function handleClick(e) {
    if (!_ready) return;
    var lbl = e.target.closest('label.color-swatch, label.option-button');
    if (!lbl) return;
    var inputId = lbl.getAttribute('for');
    if (!inputId) return;
    var input = document.getElementById(inputId);
    if (!input || input.disabled) return;

    var m = input.name.match(/\[(.*?)\]/);
    if (!m) return;
    var name = m[1].trim();
    var value = input.value;

    e.preventDefault();
    e.stopPropagation();

    if (input.checked && _selected[name] === value) {
      // Deselect — toggle off
      input.checked = false;
      delete _selected[name];
    } else {
      // Select — uncheck others in same group, check this one
      document.querySelectorAll('input[name="' + input.name + '"]').forEach(function(i) { i.checked = false; });
      input.checked = true;
      _selected[name] = value;
    }

    updateDisplay();
    updateSubmit();
  }

  // MutationObserver to fight PageFly re-disabling inputs after our init
  var _updating = false;
  var _observer = new MutationObserver(function(mutations) {
    if (_updating || !_ready) return;
    var needsUpdate = mutations.some(function(m) {
      return m.type === 'attributes' && m.attributeName === 'disabled';
    });
    if (needsUpdate) {
      _updating = true;
      updateDisplay();
      updateSubmit();
      _updating = false;
    }
  });

  function enforce() {
    if (!_ready) { init(); return; }
    _updating = true;
    updateDisplay();
    updateSubmit();
    _updating = false;
  }

  function tryInit() {
    init();
    // Start observer on .product-options once available
    if (_ready && !_observer._started) {
      var target = document.querySelector('.product-options');
      if (target) {
        _observer.observe(target, { attributes: true, subtree: true, attributeFilter: ['disabled'] });
        _observer._started = true;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }

  // Keep enforcing — PageFly may initialise late and override our states
  setTimeout(enforce, 500);
  setTimeout(enforce, 1000);
  setTimeout(enforce, 2000);
  setTimeout(enforce, 3500);
})();
